export const loadCurQuestionId = (id: string) => {
  let cachedCurQuestionId = localStorage.getItem(`curQuestionId${id}`);
  if (
    cachedCurQuestionId &&
    cachedCurQuestionId !== 'undefined' &&
    cachedCurQuestionId !== 'null'
  ) {
    return cachedCurQuestionId;
  } else {
    return '';
  }
};

export const loadCompQuestions = (id: string) => {
  let initCompleteQuestions: string[];
  let cachedCompleteQuestions = localStorage.getItem(`completeQuestions${id}`);
  if (
    cachedCompleteQuestions &&
    cachedCompleteQuestions !== 'undefined' &&
    cachedCompleteQuestions !== 'null'
  ) {
    initCompleteQuestions = JSON.parse(cachedCompleteQuestions);
  } else {
    initCompleteQuestions = [];
  }

  return initCompleteQuestions;
};
